module.exports = __webpack_public_path__ + "5f2d870d51cb3663bcac12adf49de9a5.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/alex-logo.png
 ** module id = 422
 ** module chunks = 0
 **/